import React from 'react';
import { useUI } from '../UIContext';

export default function ConfirmLeaveModal({ open, onConfirm, onCancel }) {
  const { textStyle, cardStyle } = useUI();

  if (!open) return null;

  return (
    <div style={{
      position: 'fixed',
      top: 0, left: 0, right: 0, bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.4)',
      zIndex: 1000,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '20px',
    }}>
      <div style={{
        ...cardStyle,
        background: 'var(--card-bg, #fff)',
        color: 'var(--text-color, #000)',
        maxWidth: '420px',
        width: '100%',
        padding: '24px',
        borderRadius: '16px',
        boxShadow: '0 8px 20px rgba(0, 0, 0, 0.3)',
        textAlign: 'center'
      }}>
        <h3 className="text-scaled" style={{ marginBottom: '12px' }}>Unsaved Changes</h3>
        <p style={{ ...textStyle, marginBottom: '24px' }}>
          You haven’t saved your changes. If you leave now, your edits will be lost.
        </p>
        <div style={{
          display: 'flex',
          justifyContent: 'center',
          gap: '14px',
          flexWrap: 'wrap'
        }}>
          <button
            onClick={onCancel}
            className="big-button"
            style={{
              backgroundColor: '#bbb',
              color: '#000'
            }}
          >
            Stay on Page
          </button>
          <button
            onClick={onConfirm}
            className="big-button"
            style={{
              backgroundColor: '#c0392b',
              color: '#fff'
            }}
          >
            Discard and Leave
          </button>
        </div>
      </div>
    </div>
  );
}
